var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromoHb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "5 6 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8308_3507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4336 8.21741L19.9062 11.7448C21.3555 13.194 21.3555 15.5182 19.9062 16.9674L16.8438 20.0573C16.5977 20.3307 16.1875 20.3307 15.9141 20.0846C15.668 19.8112 15.668 19.401 15.9141 19.1549L18.9766 16.0377C19.9062 15.108 19.9062 13.6041 18.9766 12.6744L15.4766 9.11975C15.2305 8.87366 15.2305 8.4635 15.5039 8.19006C15.75 7.94397 16.1602 7.94397 16.4336 8.21741ZM7 13.4127V9.31116C7 8.60022 7.57422 7.99866 8.3125 7.99866H12.3867C12.8516 7.99866 13.2891 8.19006 13.6172 8.51819L18.2109 13.1119C18.8945 13.7955 18.8945 14.9166 18.2109 15.6002L14.5742 19.2369C13.8906 19.9205 12.7695 19.9205 12.0859 19.2369L7.49219 14.6432C7.16406 14.3151 7 13.8776 7 13.4127ZM10.9375 11.0612C10.9375 10.5963 10.5273 10.1862 10.0625 10.1862C9.57031 10.1862 9.1875 10.5963 9.1875 11.0612C9.1875 11.5533 9.57031 11.9362 10.0625 11.9362C10.5273 11.9362 10.9375 11.5533 10.9375 11.0612Z",
    fill: "#ADF106"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8308_3507",
    x: -2,
    y: -1.05603,
    width: 32.3555,
    height: 30.3867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.945098 0 0 0 0 0.0235294 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8308_3507"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8308_3507",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoHb);
export default ForwardRef;